<template>
    <div class="crowdDetails pages">
        <div class="title mb-30">
            <p>
                <img src="../../assets/images/newIcon/vipset_addgroup_icon.png" alt="">
                <span>沉睡用户唤醒计划（人群营销计划名称）</span>
            </p>
            <p>
            </p>
        </div>
        <ul class="checkTab mb-30">
            
            <li :class="{'active':types==1 || types==2 || types==3}">
                <p>
                    <img src="../../assets/images/newIcon/chufa_jiben_icon.png" alt="">
                </p>
                <p>
                    <span>基本信息</span>
                </p>
            </li>
            <li :class="{'active':types==2 || types==3}">
                <p>
                    <img v-if="types!=2 && types!=3" src="../../assets/images/newIcon/chufa_scenariogray_icon.png" alt="">
                    <img v-if="types==2 || types==3" src="../../assets/images/newIcon/chufa_scenario_icon.png" alt="">
                </p>
                <p>
                    <span>场景规则</span>
                </p>
            </li>
            <li :class="{'active':types==3}">
                <p>
                    <img v-if="types!=3" src="../../assets/images/newIcon/chufa_planegray_icon.png" alt="">
                    <img v-if="types==3" src="../../assets/images/newIcon/pepolechannel_plane_icon.png" alt="">
                </p>
                <p>
                    <span>计划配置</span>
                </p>
            </li>
        </ul>
        <div class="content">
            <div class="f1" v-if="types==1">
                <el-form ref="form" :model="sizeForm" label-width="120px" size="mini">
                     <el-form-item label="业务系统:" :rules="{required: true}">
                        小橘帮帮
                    </el-form-item>
                    <el-form-item label="计划方式:" class="jihua" :rules="{required: true}">
                        <p><el-button>长期计划</el-button></p>
                        <p><span>计划执行日期：</span>2021.10.10 - 2021.11.12</p>
                        <p><span>每日通知时间：</span>18:00:00</p>
                        <p><span>用户参与限制：</span>单次/x次</p>
                    </el-form-item>
                    <el-form-item label="计划方式:" class="jihua jihua2" :rules="{required: true}">
                        <p><el-button>单次计划</el-button></p>
                        <p><span>触发时间：</span>2021.10.10 18:00:00</p>
                    </el-form-item>
                    <el-form-item label="触发条件:" :rules="{required: true}">
                        访问xxxx次/消费xxxx次/直接触发
                    </el-form-item>
                </el-form>
            </div>
            <div class="f3" v-if="types==2">
                <el-form ref="form" :model="sizeForm" label-width="120px" size="mini">
                     <el-form-item label="触发类型:" :rules="{required: true}">
                        触发型-完成A
                    </el-form-item>
                     <el-form-item label="场景规则:" :rules="{required: true}">
                        完成以下事件A后
                         <ul class="lis">
                            <li class="li" style="margin-top:15px;">
                                <div class="c">
                                    <p class="icons">
                                        <span>A</span>
                                    </p>
                                    <div>
                                        <p class="title">VIP等级包含</p>
                                        <p class="dj">
                                            <span>黄金会员</span>
                                            <span>黄金会员</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="c">
                                    <p class="icons">
                                    <span>B</span>
                                    </p>
                                    <div>
                                        <p class="title">性别 为</p>
                                        <p class="xb">
                                            <span>男</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="c">
                                    <p class="icons">
                                    <span>C</span>
                                    </p>
                                    <div style="padding-bottom:30px;">
                                        <p class="title">来源渠道 包含</p>
                                        <p class="qd">
                                            <span class="ft">小程序</span>
                                            <span class="f">
                                                <span>小程序模版消息</span>
                                                <span>小程序模版消息</span>
                                                <span>小程序模版消息</span>
                                                <span>小程序模版消息</span>
                                            </span>
                                            <span class="ft">自然注册</span>
                                            <span class="text">
                                                选择“自然注册”后，将筛选出通过自然搜索注册小程序与app的客户～
                                            </span>
                                            <span class="ft">自定义渠道</span>
                                            <span class="f">
                                                <span>公众号模版消息</span>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </li>
                            <li style="font-size: 16px;">
                                则对受众群体进行触达
                            </li>
                        </ul>
                    </el-form-item>
                </el-form>
            </div>
            <div class="f2" v-if="types==3">
                <el-form ref="form" :model="form" label-position="left" label-width="100px" size="mini">
                    <el-form-item label="通知渠道:" prop="name">
                    <ul class="channel">
                        <li>
                            <p class="ft">公众号通知</p>
                            <div class="tent">
                                <p class="ts">签到成功</p>
                                <p class="tip">尊敬的用户，你好。</p>
                                <p class="text"><span>签到时间：</span> 2021年10月10日 18:00:00</p>
                                <p class="text"><span>签到奖励：</span> 5折优惠券</p>
                                <p class="text"><span>连续签到天数：</span> 10天</p>
                                <p class="text"><span>预计签到奖励：</span> 5折优惠券，2折优惠券</p>
                                <p class="tip">感谢您的支持</p>
                                <div class="foot">
                                    <p>
                                        <img src="../../assets/images/newIcon/ai_IP_icon.png" alt="">
                                        <span>
                                            小程序名称
                                        </span>
                                        
                                    </p>
                                    <p>
                                        <img src="../../assets/images/newIcon/ai_IP_icon.png" alt="">
                                        <span>
                                            小程序
                                        </span>
                                        <i class="el-icon-arrow-right"></i>
                                    </p>
                                </div>
                            </div>
                           
                        </li>
                    </ul>
                    </el-form-item>
                     <el-form-item class="chufa" label="权益设置:">
                        <div>
                            <el-table
                                :data="tableData3"
                                :header-cell-style="{background:'#EEEEEE',textAlign: 'center',fontSize:'12px'}"
                                style="width: 100%;"
                                :cell-style="{textAlign: 'center',fontSize:'12px'}"
                                >
                                <el-table-column
                                prop="name"
                                label="优惠券名称"
                                show-overflow-tooltip
                                >
                                </el-table-column>

                                <el-table-column
                                prop="number"
                                label="类型"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="xmember"
                                label="渠道"
                                
                                cell-style="background:red;"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="lmember"
                                label="内容"
                            >
                                </el-table-column>
                                <el-table-column
                                prop="labellv"
                                label="状态"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="num"
                                label="已领取"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="num"
                                label="剩余"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="num"
                                label="已使用"
                                >
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-form-item>
                    <el-form-item class="chufa" label="完成定义:">
                        消费/登录系统/点击链接
                    </el-form-item>
                    <el-form-item class="chufa" label="标签内容:">
                        <div>
                            <el-tag size="medium" closable>沈阳市</el-tag>
                            <el-tag size="medium" closable>沈阳市</el-tag>
                            <el-tag size="medium" closable>沈阳市</el-tag>
                            <el-tag size="medium" closable>沈阳市</el-tag>
                            <el-tag size="medium" closable>沈阳市</el-tag>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
             <span  class="footer">
                <el-button class="quxiao" @click="handleClose">返回</el-button>
                <el-button class="quxiao" type="primary"  @click="types=--types" v-if="types==2 || types==3">上一步</el-button>
                <el-button type="primary"  @click="types=++types" v-if="types==2 || types==1">下一步</el-button>
                <!-- <el-button type="primary" v-if="types==3"  @click="showOk=true;">完 成</el-button> -->
            </span>
            <!-- <span  class="footer">
                <el-button class="quxiao" @click="handleClose" >返 回</el-button>
                <el-button type="primary"  @click="next">下一步</el-button>
            </span> -->
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            types:1,
            tableData: [{
                date: '小橘帮帮',
                name: '新客户人群',
                address: '129,000'
            }],
            form: {
                radtype:"2",
                name: '',
                region: '',
                date1: '',
                date2: '',
                timevalue:"",
                delivery: false,
                type: [],
                resource: '',
                desc: ''
            },
            tableData3: [{
                name: '生日活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },{
                name: '6.1活动券',
                number:"折扣券",
                xmember:"业务系统",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },{
                name: '双11大额优惠券',
                number:"优惠券",
                xmember:"积分商城",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },{
                name: '特大聚汇活动',
                number:"代金券",
                xmember:"业务系统",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },{
                name: '生日活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },{
                name: '生日活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },{
                name: '生日活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },{
                name: '生日活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },{
                name: '生日活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
            },],
            sizeForm: {
                name: '',
                region: '',
                date1: '',
                date2: '',
                delivery: false,
                type: [],
                resource: '',
                desc: ''
            }
        }
    },
    methods:{
        next(){
            this.types=++this.types;
        }
    }
}
</script>
<style lang="less" scoped>
    .title{
        display: flex;
        justify-content: space-between;
        p{
            font-size: 16px;
            font-weight: 500;
            color: #333940;
            img{
                margin-right:10px;
                width:20px;
                height:20px;
                vertical-align: middle;
                &:last-child{
                    margin-left:10px;
                    width:78px;
                    height:20px;
                }
            }
            &:last-child{
                span{
                    color: #0091FF;
                }
            }
            
        }
    }
    .footer{
        display: block;
        background: #fff;
        padding:15px 30px;
        border-top:1px solid #ededed;
        .el-button{
            border-radius: 30px;
        }
    }
    .checkTab{
        background: #fff;
        padding:60px 0;
        display: flex;
        justify-content: center;
        border-radius: 6px;
        img{
            width:100%;
            height:100%;
        }
        li{
            display: flex;
            align-items: center;
            margin-right:220px;
            position: relative;
            &:last-child{
                margin:0;
                &::after{
                    left: -206px;
                }
            }
            &:first-child{
                
                &::after{
                    display:none;
                }
                
            }
            &:nth-child(2){
                &::after{
                    left: -205px;
                }
                
            }
            
            &::after{
                content: '';
                position: absolute;
                top: 30px;
                border-bottom: 1px dashed #A7A7A7;
                width: 190px;
                height: 2px;
            }
        }
        .active{
            img{
                width:100%;
                height:100%;
            }
            &::after{
                border-bottom: 1px dashed #327EFF;
            }
            p{
                &:last-child{
                    color: #327EFF;
                }
                &:first-child{
                    // background: linear-gradient(180deg, #587FFB 0%, #3968FC 100%);
                    color:#fff;
                }
                span{
                    &:first-child{
                        color:#327EFF;
                    }
                    &:last-child{
                        color:#327EFF;
                    }
                }
            }
        }
        p{
            // text-align: center;
            &:first-child{
                margin:0 auto;
                margin-right:20px;
                width: 58px;
                height: 58px;
                border-radius: 50%;
                line-height: 63px;
                text-align: center;
                background: #EBEBEB;
                font-size: 34px;
                font-weight: 500;
                color: #fff;
            }
            &:last-child{
                font-size: 14px;
                font-weight: 400;
                color: #A1A1A1;
                span{
                    display: block;
                    color: #999990;
                    &:first-child{
                        margin-bottom:10px;
                        font-size: 20px;
                        font-weight: 500;
                        
                    }
                }
            }
        }
    }
    .content{
        .f2{
            padding:30px;
            background: #fff;
            .channel{
                display: flex;
                flex-wrap: wrap;
                li{
                    margin-right:2%;
                    margin-bottom:20px;
                    width:31%;
                    padding:15px;
                    box-sizing: border-box;
                    background: #F9F9F9;
                    border-radius: 6px;
                    border: 1px solid #F4F3F3;
                    /deep/ .el-checkbox__label{
                        font-weight: 500;
                        color: #333333;
                    }
                    .ft{
                        margin-bottom:15px;
                       font-size: 14px;
                        font-weight: 500;
                        color: #333333;
                        span{
                            color:#3373FE;
                        }
                    }
                    .uploads{
                        height:145px;
                        padding:15px 15px;
                        padding-left:30px;
                        background: #fff;
                        /deep/.avatar-uploader{
                            width:80px;
                            height:80px;
                        }
                        p{
                            display: flex;
                            margin-bottom:30px;
                           /deep/ .el-input__inner{
                               border-radius:8px;
                               width:100px;
                               background: #F6F6F9;
                           }
                            span{
                                font-size: 12px;
                                font-weight: 400;
                                color: #777777;
                            }
                            .shili{
                                margin-left:15px;
                                color:#3373FE;
                            }
                        }
                    }
                    .tent{
                        display: flex;
                        flex-direction:column;
                        justify-content: center;
                        padding:15px;
                        // height:145px;
                        // margin-top:15px;
                        background: #fff;
                        // text-align: center;
                        .ts{
                            font-size: 14px;
                            font-weight: 500;
                            color: #333333;
                        }
                        .tip{
                            margin-bottom:15px;
                            font-size: 10px;
                            font-weight: 400;
                            color: #777777;
                            &:last-of-type{
                                margin-bottom:10px;
                            }
                        }
                        .foot{
                            padding-top:10px;
                            border-top:1px solid #F4F4F4;
                            display: flex;
                            justify-content: space-between;
                            p{
                                display: flex;
                                align-items: center;
                                img{
                                    width:25px;
                                    height:25px;
                                    border-radius: 50%;
                                }
                                span{
                                    padding:0 10px;
                                }
                            }
                        }
                        .ic{
                            font-size:28px;
                            color:#327EFF
                        }
                        .t{
                            font-size: 12px;
                            font-weight: 400;
                            color: #777777;
                        }
                        .text{
                            span{
                                font-size: 10px;
                                font-weight: 400;
                                color: #777777;
                            }
                             font-size: 10px;
                            color: #333333;
                        }
                    }
                }
            }
            .tabTitle{
                margin-top:15px;
                margin-bottom:6px;
                padding:8px 30px;
                background: rgba(50, 126, 255, 0.1);
                border-radius: 4px;
                border: 1px solid #C8D8F5;
                display: flex;
                justify-content: space-between;
                /deep/ .el-button{
                    border: 1px solid #327EFF;
                    font-size: 12px;
                    font-weight: 400;
                    color: #327EFF;
                    background: #EAF2FF;
                }
                p{
                    font-size: 16px;
                    font-weight: 500;
                    color: #333940;
                    span{
                        color:#327EFF;
                    }
                }
            }
           
            /deep/ .el-checkbox__inner{
                border-radius: 50%;
            }
            /deep/ .el-tag{
                border-radius: 30px;
                margin-right:10px;
                margin-bottom:10px;
            }
        }
        .f3{
            padding:30px 0;
            background:#fff;
            .lis{
                .l{
                    margin-bottom:30px;
                    padding:15px 30px;
                    border-radius: 6px;
                    background: #F1F1F1;
                    display: flex;
                    align-items: center;
                    img{
                        margin-right:15px;
                        width:34px;
                        height:34px;
                    } 
                    font-size: 14px;
                    font-weight: 400;
                    color: #333333;
                }
                .li{
                    // margin-bottom:30px;
                    .c{
                        display: flex;
                        div{
                            padding-bottom:60px;
                        }
                        .icons{
                            display: block;
                            flex-shrink:0;
                            position: relative;
                            margin-right:30px;
                            span{
                                display: block;
                                
                                // margin-right:30px;
                                width: 24px;
                                height: 24px;
                                text-align: center;
                                line-height: 24px;
                                background: #DEEAFF;
                                border-radius: 2px;
                                font-size: 14px;
                                font-weight: 500;
                                color: #327EFF;
                            }
                            &::after{
                                content: '';
                                position: absolute;
                                top: 24px;
                                left: 10px;
                                background: #A3A3A3;
                                width: 1px;
                                height: 100%;
                            }
                            
                        }
                        &:last-child{
                            .icons{
                                &::after{
                                    display: none !important;
                                }
                            }
                            
                        }
                        .title{
                            font-size: 14px;
                            font-weight: 500;
                            color: #333333;
                        }
                        .dj {
                            padding-top:15px;
                            span{
                                margin-right:15px;
                                padding: 6px 12px;
                                background: rgba(250, 100, 0, 0.09);
                                border-radius: 16px;
                                font-size: 14px;
                                font-weight: 400;
                                color: #FF8E42;
                            }
                            
                        }
                        .xb{
                            padding-top:15px;
                            span{
                                padding: 6px 18px;
                                background: rgba(211, 236, 255, 0.47);
                                text-align: center;
                                border-radius: 16px;
                                font-size: 14px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #0091FF;
                            }
                        }
                        .qd{
                            padding-top:15px;
                            .ft{
                                padding-bottom:15px;
                                display: block;
                                font-size: 14px;
                                font-weight: 400;
                                color: #333333;
                            }
                            .text{
                                padding-bottom:15px;
                                display: block;
                                font-size: 12px;
                                font-weight: 400;
                                color: #777777;
                            }
                            .f{
                                display: block;
                                span{
                                    margin-right:8px;
                                    margin-bottom:10px;
                                    display: inline-block;
                                    padding:0px 12px;
                                    font-size: 14px;
                                    font-weight: 400;
                                    color: #FFFFFF;
                                    background: #327EFF;
                                    border-radius: 30px;
                                }                           
                            }
                        }
                    }
                }
            }
        }
        .f1{
            border-radius: 6px;
            padding:30px;
            padding-bottom:100px;
            background: #fff;
            .el-form{
                width:50%;
                img{
                    width:16px;
                    height:16px;
                    vertical-align: middle;
                }
            }
            .jihua .el-button{
                margin-bottom:15px;
                background: #FFECDF;
                font-size: 14px;
                font-weight: 400;
                color: #FA6400;
                border:0px;
                
            }
            .jihua{
                p{
                    span{
                        color:#666666;
                    }
                    font-size: 14px;
                    font-weight: 400;
                    color: #000;
                }
            }
            .jihua2{
                .el-button{
                     background: #DFF1FF;
                     color:#0091FF;
                }
            }
        }
    }
</style>